import aspida from '@aspida/axios'

import api from '../../api/$api'
import { ChainStoreEntity } from '../../api/@types'

export const getChainStores = async (
  query: {
    channelIds?: number[]
    lastId?: number
    limit?: number
  } = {},
): Promise<ChainStoreEntity[]> => {
  const instance = api(aspida())
  try {
    const data = await instance.chain_stores.$get({ query })
    return data
  } catch (error) {
    console.error(error)
    throw new Error('error.chainStores.getChainStores')
  }
}
